<div class="numbers">
    <p class="numbers__item"><span>1000+</span> new job-seeking<br> developers every month</p>
    <p class="numbers__item"><span>30</span> days to hire on<br> average</p>
    <p class="numbers__item"><span>98%</span> developer<br>response rate</p>
</div>

<style lang="postcss">
     @import '../../styles/_mixins.css';

    .numbers {
        display:flex;
        gap:40px;
        justify-content: space-evenly;
        width:1000px;
        margin:0 0 180px;

        @mixin screen-lg {
            width:100%;
        }

        @mixin screen-sm {
            flex-direction: column;
            gap:60px;
        }

        & .numbers__item {

            font-weight:600;
            color: var(--color_offerzen_lightblue_secondary);
            text-align:center;
            margin:0;
            font-size:18px;
            line-height:130%;

            @mixin screen-sm {
                font-size:22px;
            }

            & span {
                color: var(--color_offerzen_cerulean);
                display:block;
                font-size: 65px;
                font-weight:800;
                line-height:130%;

                @mixin screen-md {
                    font-size:48px;
                }

                @mixin screen-sm {
                    margin:0 0 16px;
                }
            }
        }
    }
</style>